import React from "react";
import { Link } from "react-router-dom";

export default function HomeHeader() {
  // Data for the formations
  const formations = [
    {
      title: "Hygiène et HACCP",
      description:
        "Formation sur l'hygiène et les normes HACCP pour les professionnels de la restauration et de l'industrie alimentaire.",
      image: require("../../assets/img/ValHome_Webp/Affichage.webp"),
      levels: "Débutant à intermédiaire",
      duration: "Durée a determiner selon le besoin.",
      financing: "100% pris en charge OPCO – AGEFICE – FIFPL",
      price: "À partir de 1200€",
      objectives: [
        "Comprendre les principes de l'hygiène alimentaire",
        "Maîtriser les normes HACCP pour la sécurité des aliments",
        "Appliquer les protocoles de sécurité dans les environnements de restauration et de production",
        "Identifier et prévenir les risques alimentaires",
      ],
      modalities: ["Présentiel", "E-learning"],
    },
    {
      title: "Langues",
      description:
        "La formation en langues de Valacademy Formations vous aide à améliorer vos compétences linguistiques, en couvrant la grammaire, le vocabulaire, et la communication orale et écrite, pour plusieurs langues. Adaptée à tous les niveaux, elle vous prépare à utiliser ces compétences dans des contextes professionnels et quotidiens.",
      image: require("../../assets/img/ValHome_Webp/Langue.webp"),
      levels: "Débutant à avancé",
      duration: "Durée a determiner selon le besoin.",
      financing: "100% pris en charge OPCO – AGEFICE – FIFPL",
      price: "À partir de 1000€",
      objectives: [
        "Acquérir des compétences en communication orale et écrite",
        "Améliorer la grammaire et la syntaxe",
        "Développer un vocabulaire adapté aux besoins professionnels",
        "Participer à des simulations d'entretiens professionnels dans différentes langues",
      ],
      modalities: ["Présentiel", "En visio", "E-learning"],
    },
    {
      title: "Coiffure et Esthétique",
      description:
        "La formation en coiffure et esthétique de Valacademy Formations vous enseigne les techniques modernes de coiffure, de maquillage, et de soins de beauté. Adaptée aux professionnels et débutants, elle vous permet de développer des compétences pratiques pour exceller dans l'industrie de la beauté.",
      image: require("../../assets/img/ValHome_Webp/Makeup.webp"),
      levels: "Débutant à avancé",
      duration: "Durée a determiner selon le besoin.",
      financing: "100% pris en charge OPCO – AGEFICE – FIFPL",
      price: "À partir de 1500€",
      objectives: [
        "Apprendre les techniques de coupe, coiffage et coloration",
        "Maîtriser les soins esthétiques et de la peau",
        "Développer des compétences en maquillage et soins du visage",
        "Gérer un salon de beauté et optimiser l'expérience client",
      ],
      modalities: ["Présentiel", "E-learning"],
    },
    {
      title: "CACES",
      description:
        "La formation CACES de Valacademy Formations vous prépare à l’obtention du certificat CACES, indispensable pour la conduite d'engins de chantier en toute sécurité. Elle couvre les règles de sécurité, la manipulation des équipements, et les techniques nécessaires à une conduite efficace et conforme aux normes.",
      image: require("../../assets/img/CACES (2).png"),
      levels: "Intermédiaire",
      duration: "Durée a determiner selon le besoin.",
      financing: "100% pris en charge OPCO – AGEFICE – FIFPL",
      price: "À partir de 800€",
      objectives: [
        "Acquérir les compétences nécessaires pour conduire des engins de chantier en toute sécurité",
        "Maîtriser les gestes techniques et la réglementation des engins",
        "Appliquer les bonnes pratiques de sécurité sur les chantiers",
      ],
      modalities: ["Présentiel"],
    },
    {
      title: "Intelligence Artificielle",
      description:
        "La formation en Intelligence Artificielle de Valacademy Formations vous initie aux concepts fondamentaux de l'IA, au machine learning et au deep learning, tout en vous permettant de manipuler des outils comme TensorFlow et Scikit-learn pour développer des modèles performants.",
      image: require("../../assets/img/ValHome_Webp/IA.webp"),
      levels: "Débutant à avancé",
      duration: "Durée a determiner selon le besoin.",
      financing: "100% pris en charge OPCO – AGEFICE – FIFPL",
      price: "À partir de 1500€",
      objectives: [
        "Comprendre les bases de l’intelligence artificielle et du machine learning",
        "Apprendre à entraîner et optimiser des modèles d’IA",
        "Utiliser des bibliothèques comme TensorFlow, PyTorch et Scikit-learn",
        "Appliquer l’IA à des domaines concrets : reconnaissance d’image, NLP, analyse de données",
      ],
      modalities: ["Présentiel", "En visio", "E-learning"],
    },
    // {
    //   title: "Marketing Digital",
    //   description:
    //     "La formation en marketing digital de Valacademy Formations couvre les stratégies clés du SEO, SEM, et des réseaux sociaux, vous permettant de développer des compétences pour optimiser la visibilité en ligne et gérer des campagnes marketing efficaces.",
    //   image: require("../../assets/img/ValHome_Webp/Marketing.webp"),
    //   levels: "Intermédiaire à avancé",
    //   duration: "40h",
    //   financing: "100% pris en charge OPCO – AGEFICE – FIFPL",
    //   price: "À partir de 1300€",
    //   objectives: [
    //     "Maîtriser les techniques de SEO et SEM",
    //     "Optimiser la visibilité d'un site web",
    //     "Gérer des campagnes publicitaires sur Google Ads et Facebook Ads",
    //     "Utiliser les réseaux sociaux pour augmenter la visibilité en ligne",
    //   ],
    //   modalities: ["Présentiel", "En visio", "E-learning"],
    // },
    {
      title: "Comptabilité",
      description:
        "La formation en Comptabilité de Valacademy Formations vous permet de maîtriser les bases de la gestion comptable, fiscale et financière. Idéale pour débuter ou renforcer vos compétences dans le domaine, elle prépare aux métiers de la comptabilité en entreprise ou en cabinet.",
      image: require("../../assets/img/ValHome_Webp/Comptabilite.webp"),
      levels: "Débutant à intermédiaire",
      duration: "Durée à déterminer selon le besoin.",
      financing: "100% pris en charge OPCO – AGEFICE – FIFPL",
      price: "À partir de 1500€",
      objectives: [
        "Maîtriser les principes fondamentaux de la comptabilité générale",
        "Comprendre la fiscalité des entreprises et les obligations légales",
        "Savoir établir un bilan, un compte de résultat et enregistrer les écritures comptables",
        "Utiliser des logiciels comptables courants pour automatiser les tâches",
      ],
      modalities: ["Présentiel", "E-learning"],
    },
  ];

  return (
    <div>
      <p
        style={{
          backgroundColor: "gray",
          display: "flex",
          fontSize: "2em",
          fontWeight: "bold",
          justifyContent: "center",
          padding: "1%",
          color: "white",
          textShadow: "2px 2px 8px rgba(0, 0, 0, 0.7)", // Corrected syntax
          paddingTop: "3%",
          textAlign: "center",
        }}
      >
        <div
          style={{
            background:
              "linear-gradient(to top left, #ff9900,rgb(255, 210, 128))",
            borderRadius: "50px",
            padding: "1%",
          }}
        >
          Nos formations les plus demandées
        </div>
      </p>

      <div className="newBody">
        {/* Title added here */}
        <div className="homeContainer">
          {formations.map((formation, index) => (
            <div className="imageWrapper" key={index}>
              <img src={formation.image} alt={formation.title} />
              <div className="textOverlay">{formation.title}</div>
              <Link
                className="overlayButton"
                to="/formation"
                state={{
                  name: formation.title, // changed name to title
                  image: formation.image,
                  description: formation.description,
                  reason: formation.reason, // you can change this based on your new object structure
                  benefits: formation.benefits, // you can change this based on your new object structure
                  details: formation.details, // you can change this based on your new object structure
                  levels: formation.levels, // added levels field
                  duration: formation.duration, // added duration field
                  financing: formation.financing, // added financing field
                  price: formation.price, // added price field
                  objectives: formation.objectives, // added objectives field
                  modalities: formation.modalities, // added modalities field
                }}
              >
                Programme
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
